
































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import MyForm from "@/mixins/form";

import moment from "moment";

@Component
export default class extends Mixins(MyList, MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumGrounds!: any[];

  @Prop() allowHalfAnHour!: boolean;

  forceCancelBill: boolean = false;

  curtime: number = moment().unix();

  bills: any[] = [];

  columns: any[] = [
    { title: "头像", scopedSlots: { customRender: "user_avatar" } },
    { title: "用户名", scopedSlots: { customRender: "username" } },
    { title: "订场信息", scopedSlots: { customRender: "orderinfo" } },
    { title: "下单时间", dataIndex: "created_time" },
    { title: "订单状态", scopedSlots: { customRender: "bill_status" } }
  ];

  chooseDate() {
    // 选择日期
  }

  renderTime(dtime: string) {
    return moment(dtime).unix();
  }

  disabledDate(current: any) {
    // Can not select days before today and today
    return (
      current &&
      current <=
        moment()
          .subtract(1, "day")
          .endOf("day")
    );
  }

  handleCheckOrdered() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const res = await this.$store.dispatch("stadium/checkOrdered", {
          stadium_id: this.stadiumId,
          ...values
        });
        if (res && res.Message && res.Message === "success") {
          if (res && res.Data && res.Data != "{}") {
            this.bills = res.Data;
          } else {
            // 没有已订场的订单
            this.handleSubmit("1");
          }
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  handleSubmit(forceCancelBill: string) {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;

            // console.log(values)
            const res = await this.$store.dispatch("stadium/orderedGround", {
              stadium_id: this.stadiumId,
              action: "close",
              force_cancel_bill: forceCancelBill,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  validateToTimeStart(rule: any, value: any, callback: any) {
    const { form } = this;

    const time_date_start = form.getFieldValue("time_date_start");
    const time_date_end = form.getFieldValue("time_date_end");

    let time_start = form.getFieldValue("time_start");
    if (parseInt(time_start, 10) < 10) {
      time_start = "0" + time_start;
    }
    let minute_start = form.getFieldValue("minute_start");
    let time_end = form.getFieldValue("time_end");
    if (parseInt(time_end, 10) < 10) {
      time_end = "0" + time_end;
    }
    let minute_end = form.getFieldValue("minute_end");

    console.log(time_date_start + " " + time_start + ":" + minute_start);
    console.log(time_date_end + " " + time_end + ":" + minute_end);

    const starttime = moment(
      time_date_start + " " + time_start + ":" + minute_start,
      "YYYY-MM-DD HH:mm"
    );
    const endtime = moment(time_date_end + " " + time_end + ":" + minute_end, "YYYY-MM-DD HH:mm");

    if (!starttime.isBefore(endtime)) {
      callback("结束时间要大于开始时间");
    } else {
      // form.validateFields(["time_start"]);
      callback();
    }
  }

  validateToTimeEnd(rule: any, value: any, callback: any) {
    const { form } = this;

    const time_date_start = form.getFieldValue("time_date_start");
    const time_date_end = form.getFieldValue("time_date_end");

    let time_start = form.getFieldValue("time_start");
    if (parseInt(time_start, 10) < 10) {
      time_start = "0" + time_start;
    }
    let minute_start = form.getFieldValue("minute_start");

    let time_end = form.getFieldValue("time_end");
    if (parseInt(time_end, 10) < 10) {
      time_end = "0" + time_end;
    }
    let minute_end = form.getFieldValue("minute_end");

    console.log(time_date_start + " " + time_start + ":" + minute_start);
    console.log(time_date_end + " " + time_end + ":" + minute_end);

    const starttime = moment(
      time_date_start + " " + time_start + ":" + minute_start,
      "YYYY-MM-DD HH:mm"
    );
    const endtime = moment(time_date_end + " " + time_end + ":" + minute_end, "YYYY-MM-DD HH:mm");

    if (!starttime.isBefore(endtime)) {
      callback("结束时间要大于开始时间");
    } else {
      // form.validateFields(["time_end"]);
      callback();
    }
  }
}
